import api from '../../../api'
import {browserHistory} from 'react-router'
import config from 'config';
import {changeLoading} from '../../Main/modules/main'
import test_modules from 'test_modules'
import { getTranslate, getActiveLanguage } from 'react-localize-redux'
export const ADD_PATIENT_CONSTRUCTOR = 'ADD_PATIENT_CONSTRUCTOR';
export const UPDATE_ADD_PATIENT_STATE = 'UPDATE_ADD_PATIENT_STATE';
export const HANDLE_ADD_PATIENT = 'HANDLE_ADD_PATIENT';
export const ADD_PATIENT = 'ADD_PATIENT_CONSTRUCTOR';
export const ADD_PATIENT_FALSE = 'ADD_PATIENT_FALSE';

const countries = config.country;


export function addPatientConstructor() {
  return (dispatch,getState) =>{
    return new Promise((resolve,reject)=>{
      setTimeout(function(){
        let patientsState = {...getState().patients};
        let addPatientStates = {
          patientDetail : {
            firstName : patientsState.newPatient,
            dobValid: false
          }
        }
        dispatch({
          type: UPDATE_ADD_PATIENT_STATE,
          payload: addPatientStates
        });
        resolve();
      }, 50);
      
    })
  }
}
function validateEmail(email) {
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

export function goStep(index){
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      var addPatient = {...getState().addPatient};
      let fieldIsRequire = "";
      let fieldRequire = [{id : "firstName" ,name : "firstNameValid"},{id : "lastName" ,name : "lastNameValid"},{id : "email" ,name : "emailValid"},{id : "dob" ,name : "dobValid"}];
      fieldRequire.map((field,index)=>{
        if(!addPatient.patientDetail[field.id] || addPatient.patientDetail[field.id].length == 0 /*|| field.id == "email"*/ ){
          addPatient.patientDetail[field.name] = true;
        }
      })
      if(addPatient.patientDetail.lastNameValid || addPatient.patientDetail.phoneValid || addPatient.patientDetail.firstNameValid || addPatient.patientDetail.dobValid /*|| addPatient.patientDetail.emailValid*/){
        window.scrollTo(0,0);
      }else{
        addPatient.stepIndex = index;
      }

      if(!addPatient.patientDetail.hasOwnProperty('email')) {
        addPatient.patientDetail.email = "None";
      }

      dispatch({
        type: UPDATE_ADD_PATIENT_STATE,
        payload: addPatient
      });
      resolve();
    });
  }
}




export function updateAddPatientState(key,value) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      var addPatient = {...getState().addPatient};
      addPatient[key] = value;
      dispatch({
        type: UPDATE_ADD_PATIENT_STATE,
        payload: addPatient
      });
      resolve();
    });
  }
}

export function patientDetail(id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      var patients = {...getState().patients};
      dispatch({
        type: PATIENT_DETAIL,
        payload: patients
      });
      browserHistory.push('/patient/' + id);
      resolve();
    });
  }
}

export function updatePatientDetail(key,value) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      var addPatient = {...getState().addPatient};
      if(!addPatient.patientDetail){
        addPatient.patientDetail={};
      }
      if(key === 'height' || key === 'weight') {
        value = value.replace(/[^0-9.]+/g, '');
      }
      addPatient.patientDetail[key] = value;
      dispatch({
        type: UPDATE_ADD_PATIENT_STATE,
        payload: addPatient
      });
      resolve();
    });
  }
}

export function createPatientApi(createInstapap) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      var addPatient = {...getState().addPatient};
      addPatient = convertStateToData(addPatient);
      addPatient.last_visit = new Date();
      let locale = {...getState().locale};
      let translate = getTranslate(locale);
      // addPatient.next_visit = { new Date()};
      api.post('/patients', addPatient.patient)
      .then(response => {
        dispatch({
          type: HANDLE_ADD_PATIENT,
          payload: true,
          message: translate('Added_patient_successfully')
        })
        browserHistory.push('/patient/' + response.patient._id);
        resolve();
      }, err => {
        dispatch({
          type: ADD_PATIENT_FALSE,
          payload: true,
          message: err.message
        })
      })
    });
  }
}

export function createFirstTestApi() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      var addPatient = {...getState().addPatient};
      let locale = {...getState().locale};
      let translate = getTranslate(locale);
      let newTest = {};
      newTest = convertStateToFirstTestData(addPatient);
      newTest.patient = addPatient.patientDetail._id;
      let startTime = new Date();
      dispatch(changeLoading(true));
      createExamApi(startTime,newTest,function(res){
        if(!res){
          addPatient.popupDockDevice = true;
          dispatch({
            type : UPDATE_ADD_PATIENT_STATE,
            payload : addPatient
          })
          dispatch(changeLoading(false));
          resolve();
        }else{
          dispatch(changeLoading(true));
          dispatch({
            type: ADD_PATIENT_FALSE,
            payload: true,
            message: translate('Created_exam_successfully')
          })
          browserHistory.push('/patient/' +  addPatient.patientDetail._id);
          resolve();
        }
        dispatch(changeLoading(false));
      })
    });
  }
}

function createExamApi(startTime,newTest,cb){
  let timer = Number(new Date());
  if(Number(new Date()) - startTime < 1200000 ){
    api.post('/exams/instapap',newTest,true)
    .then(response => {
      if(response.status == false){
        let timePerRequest = Number(new Date()) - timer;
        if(timePerRequest >= 10000){
          return createExamApi(startTime,newTest,cb);
        }
        setTimeout(function(){
          return createExamApi(startTime,newTest,cb);
        }, 10000 - timePerRequest);
      }else{
        return cb(response);
      }
    }, err => {
      return createExamApi(startTime,newTest,cb);
    })
  }else{
    return cb(null);
  }
}



export function createPatientAndFirstTestApi() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      var addPatient = {...getState().addPatient};
      addPatient.patientDetail = convertStateToData(addPatient);
      addPatient.patientDetail.patient.profile.last_visit = new Date();
      addPatient.patientDetail.patient.profile.next_visit = new Date();
      api.post('/patients', addPatient.patientDetail.patient)
      .then(response => {
        addPatient.patientDetail._id = response.patient._id;
        addPatient.showPupupCriteria = true;
        dispatch({
          type: UPDATE_ADD_PATIENT_STATE,
          payload: addPatient
        });
        resolve();
      }, err => {
        dispatch({
          type: ADD_PATIENT_FALSE,
          payload: true,
          message: err.message
        })
      })
    });
  }
}


function convertStateToFirstTestData(addPatient){
  let commonKeys = ["reason_for_appt","hereditary_predis","personal_predis","pathological_predis"];
  let symp_presentKeys = ["vaginal_discharge","postcoital_bleeding","cervical_bleeding","symp_present_other"];
  let observed_conditionsKeys = ["smooth","inflammation","hypertrophy","polyp","nabothian_cyst","leceration","leucoplasia","supspicious_lesion","observed_conditions_other"];
  let notesKeys = ["report","physical","current_condition"];
  let data ={
    test_type : "Instapap",
    status : 1,
    test_date : new Date(),
    results_date :new Date(),
    symp_present : [],
    obs_conditions:[],
    notes : {}
  }
  Object.keys(addPatient.patientDetail).map((key,index)=>{
    if(commonKeys.indexOf(key)>-1){
      data[key]=addPatient.patientDetail[key];
    }
    if(symp_presentKeys.indexOf(key)>-1 ){
      let temp = {};
      temp[key] = addPatient.patientDetail[key];
      data.symp_present.push(temp);
    }
    if(observed_conditionsKeys.indexOf(key)>-1){
      let temp = {};
      temp[key] = addPatient.patientDetail[key];
      data.obs_conditions.push(temp);
    }
    if(notesKeys.indexOf(key)>-1){
      data.notes[key]=addPatient.patientDetail[key];
    }
  })
  return data;
}

export function abandonTest(exam){
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
        var patientDetail = { ...getState().addPatient }
        api.delete('/exams/instapap/',{exam_id : exam ? patientDetail.examTemp._id : null})
        .then(response => {
          patientDetail.showPupupCriteria = false;
          patientDetail.showWaitingDockDevicePop = false;
          patientDetail.exclusionCriteria = false;
          patientDetail.showInterviewPopup = false;
          patientDetail.exclusionCriteria = false;
          dispatch({
            type: UPDATE_ADD_PATIENT_STATE,
            payload: patientDetail
          })
          resolve()
        }, err => {
          dispatch({
            type: UPDATE_ADD_PATIENT_STATE,
            payload: patientDetail
          })
          resolve()
        })
    })
  }
}



export function updateNewTest(){
  let commonKeys = ["reason_for_appt","hereditary_predis","personal_predis","pathological_predis"];
  let symp_presentKeys = ["vaginal_discharge","postcoital_bleeding","cervical_bleeding","symp_present_other"];
  let observed_conditionsKeys = ["smooth","inflammation","hypertrophy","polyp","nabothian_cyst","leceration","leucoplasia","supspicious_lesion","observed_conditions_other"];
  let notesKeys = ["report","physical","current_condition"];
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
          var patientDetail = { ...getState().addPatient }
          if(patientDetail.patientDetail && !patientDetail.patientDetail.cervical_bleeding){
            patientDetail.patientDetail.cervical_bleeding =1;
          }
          let data ={
            _id : patientDetail.examTemp._id,
            symp_present : [],
            obs_conditions:[],
            notes : {},
            patient : patientDetail.patientDetail._id
          }
          symp_presentKeys.forEach(item=>{
            let temp={};
            temp[item] = false;
            data.symp_present.push(temp);
          })
          observed_conditionsKeys.forEach(item=>{
            let temp={};
            temp[item] = false;
            data.obs_conditions.push(temp);
          })
          Object.keys(patientDetail.patientDetail).map((key,index)=>{
            if(commonKeys.indexOf(key)>-1){
              data[key]=patientDetail.patientDetail[key];
            }
            if(symp_presentKeys.indexOf(key)>-1 ){
              let temp = {};
              temp[key] = patientDetail.patientDetail[key]
              data.symp_present[symp_presentKeys.indexOf(key)] = temp;
            }
            if(observed_conditionsKeys.indexOf(key)>-1){
              let temp = {};
              temp[key] = patientDetail.patientDetail[key]
              data.obs_conditions[observed_conditionsKeys.indexOf(key)] = temp;
            }
            if(notesKeys.indexOf(key)>-1){
              data.notes[key]=patientDetail.patientDetail[key];
            }
          })
          data.pre_conditions =[];
          if(!patientDetail.exclusionCriteria){
            patientDetail.exclusionCriteria ={};
          }
          data.pre_conditions = test_modules.pre_conditionsKeys.map(function(item,i){
            let temp={};
            if(patientDetail.exclusionCriteria[item]){
              temp[test_modules.pre_conditionsKeys[i]] = true;
              return temp;
            }else{
              temp[test_modules.pre_conditionsKeys[i]] = false;
              return temp;
            }
          })
          api.put('/exams',data,true)
          .then(response => {
            browserHistory.push('/patient/' + patientDetail.patientDetail._id);
          },err=>{
            console.log(err);
          })
      })
  }
}

export function createTest(){
  return (dispatch, getState) => {
    function createExamApi(startTime,newTest,cb){
        var currentPatientDetail = { ...getState().addPatient }
        if(currentPatientDetail.disConnect){
          dispatch(updateAddPatientState("disConnect",false))
          dispatch(updateAddPatientState("showWaitingDockDevicePop",false))
          return cb(null);
        }
        let timer = Number(new Date());
        let created_at = currentPatientDetail.newTestTime;
        if(Number(new Date()) - startTime < 1200000 ){
          newTest.time = new Date();
          api.post('/exams/instapap?created_at='+created_at,newTest,true)
          .then(response => {
            if(response.status == false){
              let timePerRequest = Number(new Date()) - timer;
              if(timePerRequest >= 10000){
                return createExamApi(startTime,newTest,cb);
              }
              setTimeout(function(){
                return createExamApi(startTime,newTest,cb);
              }, 10000 - timePerRequest);
            }else{
              dispatch(updateAddPatientState("showWaitingDockDevicePop",false))
              return cb(response);
            }
          }, err => {
            return createExamApi(startTime,newTest,cb);
          })
        }else{
          dispatch(updateAddPatientState("showWaitingDockDevicePop",false))
          dispatch(updateAddPatientState("showPopupDockDeviceComplete",true))
          return cb(null);
        }
    }
    return new Promise((resolve, reject) => {
        var patientDetail = { ...getState().addPatient }
        let data ={
          patient : patientDetail.patientDetail._id
        }
        dispatch(updateAddPatientState("showWaitingDockDevicePop",true))
        let startTime = new Date();
        createExamApi(startTime,data,function(res){
          if(res){
            dispatch(updateAddPatientState("examTemp",res.exam))
            dispatch(updateAddPatientState("showPupupCriteria",false))
            dispatch(updateAddPatientState("stepIndex",5))
          }else{
            console.log("fail");
          }
        })
    })
  }
}

//GVANCE'S CODE
// export function createTest(){
//   return (dispatch, getState) => {
//     let created_at = new Date();
//     var createExamApi = function createExamApi(cb){
//       api.post('/exams/instapap?created_at='+created_at,{},true)
//       .then((response) => {
//         if(response.status == false) return setTimeout(function(){ createExamApi(cb) }, 1000);
//         dispatch(updateAddPatientState("showWaitingDockDevicePop",false))
//         return cb(response);
//       });
//     };
//     return new Promise((resolve, reject) => {
//         var patientDetail = { ...getState().addPatient }
//         let data ={
//           patient : patientDetail.patientDetail._id
//         }
//         dispatch(updateAddPatientState("showWaitingDockDevicePop",true))
//         createExamApi(function(res){
//           if(res){
//             console.log(res);
//             dispatch(updateAddPatientState("examTemp",res.exam))
//             dispatch(updateAddPatientState("showPupupCriteria",false))
//             dispatch(updateAddPatientState("stepIndex",5))
//           }else{
//             console.log("fail");
//           }
//         })
//     });
//   }
// }

function convertStateToData(addPatient){
  let profileKeys=["email","phone","dob","last_visit","next_visit","ref_by"];
  let addressKeys = ["lines","city","state","zip","country"];
  let nameKeys=["firstName","lastName"];
  let historyKeys= ["pathological_predis","personal_predis","hereditary_predis","reason_for_appt","ethnicity","height","weight","cigarettes_day","pregnancies","liveBirths","cesareans","abortions","sexual_partners","first_sex","last_pap_smear","last_menstruation"];
  let testDataKeys =["reason_for_appt","hereditary_predis","personal_predis","pathological_predis","vaginal_discharge","postcoital_bleeding"];
  let testCondKeys = ["smooth","inflam","hipert","polop","nabothian_cyst","laceration","leucoplasia","leucoplasia"];
  let data = {
    patient :{
      active : true,
      profile : {
        name: {},
        address:{},
      },
      history : {},
      status : {},
      whats_app : ""
    },
    test : {
      data :{},
      conditions : {}
    }
  };
  Object.keys(addPatient.patientDetail).map((key,index)=>{
    if(profileKeys.indexOf(key)>-1){
      data.patient.profile[key]=addPatient.patientDetail[key];
    }
    if(addressKeys.indexOf(key)>-1){
      data.patient.profile.address[key]=addPatient.patientDetail[key];
    }
    if(key =="country"){
      data.patient.profile.address[key]=countries[addPatient.patientDetail[key]];
    }
    if(key == "firstName"){
      data.patient.profile.name.first=addPatient.patientDetail[key];
    }
    if(key == "lastName"){
      data.patient.profile.name.last=addPatient.patientDetail[key];
    }
    if(historyKeys.indexOf(key)>-1){
      data.patient.history[key]=addPatient.patientDetail[key];
    }
    if((key=="smoker" || key=="anal_sex") && addPatient.patientDetail[key]==1){
      data.patient.history[key]=true;
    }
    if((key=="smoker" || key=="anal_sex") && addPatient.patientDetail[key]==0){
      data.patient.history[key]=false;
    }
    if(testDataKeys.indexOf(key)>-1){
      data.test.data[key]=addPatient.patientDetail[key];
    }
    if(testCondKeys.indexOf(key)>-1){
      data.test.conditions[key]=addPatient.patientDetail[key];
    }
  })
  if(!data.patient.profile.address.country || data.patient.profile.address.country.length == 0){
    data.patient.profile.address.country = "Mexico";
  }
  return data;
}

const initialState = {}


export function addPatient() {
  return initialState;
}


const ADD_PATIENT_ACTION_HANDLERS = {
  [ADD_PATIENT_CONSTRUCTOR]    : (state, action) => action.payload,
  [UPDATE_ADD_PATIENT_STATE] :  (state, action) => action.payload,
  [HANDLE_ADD_PATIENT] : (state, action) => {
    return Object.assign({}, state, {
      message: action.message
    })
  },
  [ADD_PATIENT] : (state, action) => {
    return Object.assign({}, state, {
      message: action.message
    })
  },
  [ADD_PATIENT_FALSE] : (state, action) => {
    return Object.assign({}, state, {
      message: action.message
    })
  },
}

export default function counterReducer (state = initialState, action) {
  const handler = ADD_PATIENT_ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/routes/AddPatient/modules/addpatient.js